import { HoppModule } from "@hoppscotch/common/modules"
import { def } from "@app/platform/auth/desktop/index"
import { enterpriseAuthEvents$ } from "@app/platform/auth/events"
import { ref } from "vue"

const isUserDeactivated = ref(false)

const whoIsAccessing = async () => {
  if (isUserDeactivated.value) return "DEACTIVATED"

  const probableUser = def.getProbableUser()
  if (probableUser) {
    await def.waitProbableLoginToConfirm()
    if (def.getCurrentUser()) return "AUTHENTICATED"
  }
  return "GUEST"
}

export const UserAccountStatus: HoppModule = {
  onRouterInit(_, router) {
    enterpriseAuthEvents$.subscribe((event) => {
      if (event.type === "user_deactivated") {
        isUserDeactivated.value = true
        router.push({
          path: "/login-required",
          query: {
            error: "state.user_deactivated",
          },
        })
      }
    })
  },

  async onBeforeRouteChange(to, _, router) {
    const userStatus = await whoIsAccessing()

    if (to.meta.onlyGuest && userStatus === "GUEST") return
    if (!to.meta.onlyGuest && userStatus === "AUTHENTICATED") return

    if (userStatus === "DEACTIVATED" && !to.path.includes("/login-required")) {
      router.push({
        path: "/login-required",
        query: {
          error: "state.user_deactivated",
        },
      })
      return
    }

    if (to.meta.onlyGuest && userStatus === "AUTHENTICATED") {
      router.replace("/")
      return
    }
  },
}
